import type { Ref } from 'react';
import { HomeStatus } from './HomeStatus';
import { NameField } from './NameField';
import type { HomeAction } from './PlayView';

/** Home → the menu: wordmark, name, then Play, Join Lobby and Options. */
export function MainMenu({
  pending,
  onPlay,
  onJoin,
  onOptions,
  optionsRef,
}: {
  pending: HomeAction | null;
  onPlay: () => void;
  onJoin: () => void;
  onOptions: () => void;
  /** Focus returns here when Options closes. */
  optionsRef: Ref<HTMLButtonElement>;
}) {
  return (
    <nav className="home-menu" aria-label="Main menu">
      <h1 className="wordmark">Arcane Ring</h1>
      <NameField onSubmit={onPlay} />
      <button className="menu-button primary" onClick={onPlay}>
        Play
      </button>
      <button className="menu-button" onClick={onJoin}>
        Join Lobby
      </button>
      <button className="menu-button" ref={optionsRef} onClick={onOptions}>
        Options
      </button>
      {/* A resumed session connects with no button pressed. */}
      <HomeStatus pending={pending} />
    </nav>
  );
}
